"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Store = _interopRequireDefault(require("./Store"));

var _Feedback = _interopRequireDefault(require("./Feedback"));

var _AutocompleteField = _interopRequireDefault(require("./AutocompleteField"));

require("./loadableAutocomplete.css");

/** Dynamic autocomplete field for fetching autocomplete options based on the user's input */
var LoadableAutocomplete =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(LoadableAutocomplete, _React$Component);

  function LoadableAutocomplete() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LoadableAutocomplete);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LoadableAutocomplete)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getComponentStoreProps", function () {
      return {
        onResetState: function onResetState() {
          return _this.onResetState();
        },
        minCharsRequired: _this.props.minCharsRequired,
        shouldResetInternalState: _this.props.shouldResetInternalState,
        optionIdName: _this.props.optionIdName,
        handleOptionsResponse: _this.props.handleOptionsResponse,
        onSelectHook: _this.props.onSelectHook,
        onChangeHook: _this.props.onChangeHook,
        optionDisplayNameKey: _this.props.optionDisplayNameKey,
        apiCallDelay: _this.props.apiCallDelay,
        getURLForOptions: _this.props.getURLForOptions,
        fetchRequestOptions: _this.props.fetchRequestOptions
      };
    });
    return _this;
  }

  (0, _createClass2.default)(LoadableAutocomplete, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return _react.default.createElement(_Store.default, this.getComponentStoreProps(), function (loadableAutocompleteStore) {
        var store = loadableAutocompleteStore;
        return _react.default.createElement("div", _this2.getRootProps(), _react.default.createElement("div", {
          className: "auto-complete-wrapper"
        }, _this2.getLoadableAutocompleteUI(store), _this2.getFeedbackForUser(store)), typeof _this2.props.children === 'function' && _this2.props.children(store));
      });
    }
  }, {
    key: "getLoadableAutocompleteUI",
    value: function getLoadableAutocompleteUI(store) {
      return _react.default.createElement(_AutocompleteField.default, {
        loadableAutocompleteStore: store,
        optionIdName: this.props.optionIdName,
        optionDisplayNameKey: this.props.optionDisplayNameKey,
        getOptionLabel: this.props.getOptionLabel,
        getAutocompleteFieldNames: this.props.getAutocompleteFieldNames,
        rcForm: this.props.rcForm,
        fieldId: this.props.fieldId,
        placeholder: this.props.placeholder,
        hasSearchIcon: this.props.hasSearchIcon,
        isClearable: this.props.isClearable
      });
    }
  }, {
    key: "getFeedbackForUser",
    value: function getFeedbackForUser(store) {
      return _react.default.createElement(_Feedback.default, {
        loadableAutocompleteStore: store,
        inputRequiredFeedback: this.props.inputRequiredFeedback,
        canShowSuccess: this.props.canShowSuccess,
        hasSubmissionError: this.props.hasSubmissionError,
        optionDisplayNameKey: this.props.optionDisplayNameKey,
        minCharsRequired: this.props.minCharsRequired
      });
    }
  }, {
    key: "getRootProps",
    value: function getRootProps() {
      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className;
      return {
        className: className,
        style: style
      };
    }
  }, {
    key: "onResetState",
    value: function onResetState() {
      var _this$props2 = this.props,
          rcForm = _this$props2.rcForm,
          fieldId = _this$props2.fieldId;

      if (rcForm && fieldId) {
        rcForm.setFieldsValue((0, _defineProperty2.default)({}, fieldId, ''));
      }
    }
  }]);
  return LoadableAutocomplete;
}(_react.default.Component);

exports.default = LoadableAutocomplete;
LoadableAutocomplete.propTypes = {
  /** (userInput: string) => string; function that should return the full url for the autocomplete's options, given the current state of the user's input*/
  getURLForOptions: _propTypes.default.func.isRequired,

  /** The name of the key on the autocomplete option object that points to the object's unique id value. */
  optionIdName: _propTypes.default.string.isRequired,

  /** The name of the key on the autocomplete option object that points to the object's display name. */
  optionDisplayNameKey: _propTypes.default.string.isRequired,

  /** (options: option[]) => option[]; function that should return array of option objects given the API response results for fetching the autocomplete's options. */
  handleOptionsResponse: _propTypes.default.func,

  /** (selectedOptionState) => void; if defined, this will be called whenever the user selects an option */
  onSelectHook: _propTypes.default.func,

  /** (internalState, nextInput) => void; if defined, this will be called whenever the user changes the value in the input field, and before the state is set. */
  onChangeHook: _propTypes.default.func,

  /** (option) => string; given the options object, should return a display label for the option. If undefined, the label defaults to option[optionDisplayNameKey] */
  getOptionLabel: _propTypes.default.func,

  /** (loadableAutocompleteStore) => Jsx; gives you access to the component's internal store */
  children: _propTypes.default.func,

  /** (internalState) => string; optional function that will add classNames to the autocomplete field */
  getAutocompleteFieldNames: _propTypes.default.func,

  /** Overwrite the message shown to the user if they try to submit the field without any input */
  inputRequiredFeedback: _propTypes.default.string,

  /** Options object passed to the internal fetch request. */
  fetchRequestOptions: _propTypes.default.object,

  /** For integration with rcForm if the autocomplete field is being used in this context. */
  rcForm: _propTypes.default.object,

  /** Will display a "search" icon if true */
  hasSearchIcon: _propTypes.default.bool,

  /** Will completely clear the input field if the user hits backspace if true */
  isClearable: _propTypes.default.bool,

  /** The id attribute for the autocomplete field */
  fieldId: _propTypes.default.string,

  /** Optional indicator to tell the component to reset itself  */
  shouldResetInternalState: _propTypes.default.bool,

  /** Flag for displaying a sucess state below the input field indicating that the user successfully selected a valid option. */
  canShowSuccess: _propTypes.default.bool,

  /** Placeholder for the autocomplete field. */
  placeholder: _propTypes.default.string,

  /** className prop for the root <div> of the component */
  className: _propTypes.default.string,

  /** (internalState) => bool; if it returns true, a "Required" message will appear below the component */
  hasSubmissionError: _propTypes.default.func,

  /** The number of milliseconds between when a user adds a character to the input and when the API request is sent for the options */
  apiCallDelay: _propTypes.default.number,

  /** The minimum number of characters required in the input for an API call to be issued for the autocomplete's options */
  minCharsRequired: _propTypes.default.number,

  /** inline styles to be applied on the root <div> */
  style: _propTypes.default.object
};
LoadableAutocomplete.defaultProps = {
  fieldId: 'loadableAutocompleteField',
  className: 'loadable-autocomplete__root',
  placeholder: 'Start typing to see results',
  shouldResetInternalState: false,
  canShowSuccess: true,
  hasSubmissionError: function hasSubmissionError() {
    return false;
  },
  apiCallDelay: 450,
  minCharsRequired: 3,
  isClearable: true,
  style: {},
  hasSearchIcon: false
};